<div class="button-add-mobile">
    <button type="button" class="cdx-button cdx-button--primary cdx-button--icon cdx-fab cdx-button--float-right"
      (click)="onClickAddEnvelope()">
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','plus']"></fa-icon>
    </button>
</div>
